import { useState } from 'react';

import Icon from 'components/shared/Icon/Icon';

const CollapsibleSection = ({ title, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="overflow-hidden rounded-md border border-solid border-neutral-200 bg-white">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left transition-colors hover:bg-neutral-50">
        <span className="text-sm font-500 text-neutral-900">{title}</span>
        <Icon icon={open ? 'chevron-up-mono' : 'chevron-down-mono'} size={14} color="neutral" />
      </button>
      {open ? (
        <div className="border-t border-solid border-neutral-100 px-3 py-2">{children}</div>
      ) : null}
    </div>
  );
};

export default CollapsibleSection;
